import React from 'react'

import { Box, Item, Text } from '@factorialco/deprecated-design-system'
import { A3innuvaContractsEducationLevelsFragment } from 'generated/resources/graphql'

import { EducationLevelDropdown } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/EducationalLevel/EducationalLevelDropdown'

interface EducationLevelItemProps {
  educationLevel: A3innuvaContractsEducationLevelsFragment
  selectedValue: string
  options: Item[]
  onSelect: (value: string, label: string) => void
  loading: boolean
}

export const EducationLevelItem: React.FC<EducationLevelItemProps> = ({
  educationLevel,
  selectedValue,
  options,
  onSelect,
  loading,
}) => (
  <Box flexDirection="row" justifyContent="spaceBetween" maxWidth="s600">
    <Box paddingTop="s12" width="s300">
      <Text.Header3>{educationLevel.name}</Text.Header3>
    </Box>
    <Box width="s300">
      <EducationLevelDropdown
        name={`education_level_${educationLevel.id}`}
        selectedValue={selectedValue}
        options={options}
        onSelect={onSelect}
        loading={loading}
      />
    </Box>
  </Box>
)
